import { DBDef_EHRFlowsheetConfiguration, DBDef_EHRInstance, DBDef_EHROrderConfiguration } from '@app/org-shared';
import { ModuleFE_EHRInstance, ModuleFE_Organization } from '../_entity.js';
import { ModuleFE_FlowSheet } from '@app/advisor-content-frontend/index';
import { ModuleFE_Action } from '@app/pathway-frontend';
const getConfigPrefix = (ehrInstanceId) => {
    const ehrInstance = ModuleFE_EHRInstance.cache.unique(ehrInstanceId);
    const org = ModuleFE_Organization.cache.unique(ehrInstance?.organizationId);
    if (!org || !ehrInstance)
        return;
    return `${org.name} > ${ehrInstance.label}`;
};
const getFlowsheetLabel = (config) => {
    const flowSheet = ModuleFE_FlowSheet.cache.unique(config.dbNoteId);
    const prefix = getConfigPrefix(config.ehrInstanceId);
    if (!prefix || !flowSheet)
        return;
    return `${prefix} > ${flowSheet.label}`;
};
const getOrderConfigLabel = (config) => {
    const order = ModuleFE_Action.cache.unique(config.orderId);
    const prefix = getConfigPrefix(config.ehrInstanceId);
    if (!prefix || !order)
        return;
    return `${prefix} > ${order.name}`;
};
const getEHRInstanceLabel = (instance) => {
    const org = ModuleFE_Organization.cache.unique(instance.organizationId);
    return `${org?.name ?? 'N/A Organization'} > ${instance.label}`;
};
const conflictResolutionItem_EHRFlowSheetConfiguration = {
    dbKey: DBDef_EHRFlowsheetConfiguration.dbKey,
    collectionRenderer: () => 'EHR Flowsheet Configurations',
    renderer: config => getFlowsheetLabel(config),
    filterMapper: config => {
        const label = getFlowsheetLabel(config);
        return label ? [label] : [];
    }
};
const conflictResolutionItem_EHROrderConfiguration = {
    dbKey: DBDef_EHROrderConfiguration.dbKey,
    collectionRenderer: () => 'EHR Order Configuration',
    renderer: config => getOrderConfigLabel(config),
    filterMapper: config => {
        const label = getOrderConfigLabel(config);
        return label ? [label] : [];
    }
};
const conflictResolutionItem_EHRInstance = {
    dbKey: DBDef_EHRInstance.dbKey,
    collectionRenderer: () => 'EHR Instance',
    renderer: getEHRInstanceLabel,
    filterMapper: instance => {
        const label = getEHRInstanceLabel(instance);
        return label ? [label] : [];
    }
};
export const ConflictResolutionItemGroup_Organization = [
    conflictResolutionItem_EHRFlowSheetConfiguration,
    conflictResolutionItem_EHROrderConfiguration,
    conflictResolutionItem_EHRInstance,
];
//# sourceMappingURL=conflict-resolution-items.js.map